import React from 'react';
import { Column } from '../../hooks/useTablePages';
import { format, parseISO } from 'date-fns';
import Icon from '../Icon/Icon';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import { Credential } from './types';
import { Flex } from 'rebass';

const columns: Column[] = [
  {
    header: 'Certification',
    id: 'value',
    accessor: (row: Credential) => (
      <Flex flexDirection="row" alignItems="center" sx={{ gap: 1 }}>
        {row.value}
        {row.image && (
          <Icon title={row.image.contentType} icon="file" size="16" />
        )}
      </Flex>
    ),
    stringAccessor: (row) => row.value,
    width: 160,
  },
  {
    header: 'Issuer',
    id: 'issuer',
    accessor: (row: Credential) => {
      if (row.issuer === 'STATE' || row.issuer === 'COUNTY') {
        return row.state;
      }
      if (row.issuer === 'CITY') {
        return `${row.city}, ${row.state}`;
      }
      if (row.issuer === 'WATER_SUPPLIER') {
        return constantToLabel(row.issuer);
      }
      return row.issuer;
    },
    width: 75,
  },
  {
    header: 'Issued',
    id: 'issued',
    accessor: (row: Credential) => {
      if (!row.issueDate) {
        return '';
      }
      return String(format(parseISO(row.issueDate), 'MMM d yyyy'));
    },
    width: 100,
  },
  {
    header: 'Expires',
    id: 'expires',
    accessor: (row: Credential) => {
      if (!row.expireDate) {
        return '';
      }
      return String(format(parseISO(row.expireDate), 'MMM d yyyy'));
    },
    width: 100,
  },
];

export default columns;

// Should this move to the Gauges directory?
